export const EstadoSolicitud = Object.freeze({
  PENDIENTE: 1,
  COTIZADA: 2,
  ACEPTADA: 3,
  RECHAZADA: 4,
  ANULADA: 5,
  A_COTIZAR: 6,
  CON_PROPUESTA: 7,
});
